// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import { v4 as uuidv4 } from "uuid";

// Constant functions

// Flatten array to specified depth
const flatDeep = function (arr, d = 1) {
  try {
    return d > 0
      ? arr.reduce(
        (acc, val) =>
          acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val),
        []
      )
      : arr.slice();
  } catch (error) {
    console.log("18 : Index Util : Error in flatDeep : ", error?.message);
  }
};

// Convert text to URL-friendly slug
const slugify = function (text) {
  try {
    return (
      (text || "")
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        // .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "")
    ); // Trim - from end of text
  } catch (error) {
    console.log("34 : Index Util : Error in slugify : ", error?.message);
  }
};

const slugifyV2 = function (text) {
  try {
    return (
      (text || "")
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "") // Remove all special characters
        .replace(/\s+/g, "-")         // Replace spaces with -
        .replace(/-+/g, "-")          // Replace multiple - with single -
        .replace(/^-+/, "")           // Trim - from start
        .replace(/-+$/, "")           // Trim - from end
    ); // Trim - from end of text
  } catch (error) {
    console.log("53 : Index Util : Error in slugifyV2 : ", error?.message);
  }
}

// Check if the object exists in list by slug
const containsObject = function (obj, list) {
  try {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].slug === obj.slug) {
        return i;
      }
    }
    return -1;
  } catch (error) {
    console.log("49 : Index Util : Error in containsObject : ", error?.message);
  }
};

// Format number as USD price
const formatPrice = (number = 0) => {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);
  } catch (error) {
    console.log("61 : Index Util : Error in formatPrice : ", error?.message);
  }
};

// Get unique values from data by type, optionally with 'all'
const getUniqueValues = (data, type, withAll = "active") => {
  try {
    let unique = data.map((item) => item[type]);
    if (withAll === "active") {
      return ["all", ...new Set(unique)];
    } else {
      return [...new Set(unique)];
    }
  } catch (error) {
    console.log(
      "75 : Index Util : Error in getUniqueValues : ",
      error?.message
    );
  }
};

// Get unique items with count and slug
const getUniqueValues2 = (data, itemName) => {
  try {
    const items = data.map((item) => {
      return item.itemName;
    });

    let singleCatArray = flatDeep(items);
    let itemArray = [];
    singleCatArray.forEach((cat) => {
      const obj = {
        title: cat.trim(),
        slug: slugify(cat),
        count: 1,
      };
      const objIndex = containsObject(obj, itemArray);
      if (objIndex !== -1) {
        const prevCount = itemArray[objIndex].count;
        itemArray[objIndex] = {
          title: cat.trim(),
          slug: slugify(cat),
          count: prevCount + 1,
        };
      } else {
        itemArray.push(obj);
      }
    });
  } catch (error) {
    console.log(
      "107 : Index Util : Error in getUniqueValues2 : ",
      error?.message
    );
  }
};

// Categorize courses by category
const getCategorizedData = (courses, categories) => {
  let categoryList = {};
  let courseByCategoryMap = new Map();
  let categorizedCourses = [];

  try {
    (courses || []).forEach((item) => {
      item.isPublished === true &&
        item.categories &&
        item.categories.forEach((categoryName) => {
          let matchedCategory = categories
            ? categories.find(
              (c) =>
                (c.title || "").toLowerCase() ===
                (categoryName || "").toLowerCase()
            )
            : null;

          if (categoryList[categoryName]) {
            categoryList[categoryName]++;
            const mapEntry = courseByCategoryMap.get(categoryName);
            mapEntry.courses.push(item);
            mapEntry.numberOfCourses = `${categoryList[categoryName]} courses`;
          } else if (matchedCategory) {
            categoryList[categoryName] = 1;
            courseByCategoryMap.set(categoryName, {
              ...matchedCategory,
              courses: [item],
              numberOfCourses: "1 course",
            });
          }
        });
    });

    categorizedCourses = [...courseByCategoryMap.values()];
  } catch (error) {
    console.error(
      "145 : Index Util : An error occurred while categorizing courses:",
      error?.message
    );
    showToast(
      "error",
      "Sorry, something went wrong while categorizing the courses. Please try again later.",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    categorizedCourses = [];
  }

  return categorizedCourses;
};

// Categorize all courses, including empty categories
const getAllCategorizedData = (courses, categories) => {
  let categoryCounts = {};
  let courseByCategoryMap = new Map();
  try {
    categories.forEach((category) => {
      courseByCategoryMap.set(category.title, {
        ...category,
        courses: [],
        numberOfCourses: "0 course",
      });
      categoryCounts[category.title] = 0;
    });

    (courses || []).forEach((course) => {
      (course.categories || []).forEach((categoryName) => {
        let matchedCategory = courseByCategoryMap.get(categoryName);
        if (matchedCategory) {
          categoryCounts[categoryName] += 1;
          matchedCategory.courses.push(course);
          matchedCategory.numberOfCourses = `${categoryCounts[categoryName]
            } course${categoryCounts[categoryName] > 1 ? "s" : ""}`;
        }
      });
    });

    return [...courseByCategoryMap.values()];
  } catch (error) {
    console.error(
      "183 : Index Util : An error occurred while categorizing courses:",
      error?.message
    );
    showToast(
      "error",
      "Sorry, something went wrong while categorizing the courses. Please try again later.",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    return [];
  }
};

// Set a cookie
const setCookie = (cookieName, value, expirationDate) => {
  document.cookie = `${cookieName}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
};

// Extract text content form HTML string
const extractContent = (s) => {
  try {
    var span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  } catch (error) {
    console.log(
      "201 : Index Util : Error while extracting contents from html desc: ",
      error?.message
    );
    throw error;
  }
};

// Estimate readint time in minutes
const readingTime = (article) => {
  try {
    const text = extractContent(article);
    const wpm = 200;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    return time;
  } catch (error) {
    console.log(
      "215 : Index Util : Error while calculating reading time : ",
      error?.message
    );
    throw error;
  }
};

// Generate a random background color from a string
const _setBgColor = (str) => {
  try {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "";
    if (str === "Guest User") {
      color = `#F86F03`;
    } else {
      color = `hsl(${hash % 360}, 70%, 50%)`; // HSL ensures vibrant colors
    }
    return color;
  } catch (error) {
    console.log("235 : Index Util : Error in _setBgColor : ", error?.message);
  }
};

// Toggle password field visibility
const toggle_password = () => {
  try {
    const x = document.getElementById("password");
    const y = document.getElementById("confirmPassword");
    if (x) {
      const newType = x.type === "password" ? "text" : "password";
      x.type = newType;
      if (y) {
        y.type = newType;
      }
    }
  } catch (error) {
    console.log("252 : util index : Error in toggle_password : ", error);
  }
};

// Copy to clip board
const copy_to_clipboard = async (content) => {
  try {
    await navigator.clipboard.writeText(content);
    showToast(
      "success",
      "Copied to clipboard !",
      true,
      "bottom",
      false,
      true,
      3000
    );
  } catch (error) {
    console.log("262 : Index Util : Error while coping content => ", error);
    showToast("error", "Can't copy now", true, "bottom", false, true, 3000);
  }
};

// for unique id generate
const getOrCreateGuestId = () => {
  try {
    let guestId = localStorage.getItem(
      process.env.REACT_APP_LONGSWITCH_ACADEMY_GUEST_USER
    );
    if (!guestId) {
      // guestId = "e98d169a-ea94-47ff-98e0-001a6ba05284";
      guestId = uuidv4(); // changed by longswitch team - 17/09/2026
      localStorage.setItem(
        process.env.REACT_APP_LONGSWITCH_ACADEMY_GUEST_USER,
        guestId
      );
    }
    return guestId;
  } catch (error) {
    console.log("277 : Index : Error in getOrCreateGuestId:", error.message);
  }
};

// for text truncation
const truncateText = (text, maxChar = 27) => {
  try {
    if (text && text.length > maxChar) {
      const truncatedText = text?.slice(0, maxChar) + "...";
      return truncatedText;
    }
    return text;
  } catch (error) {
    console.log("258 : Index : Error in truncateText:", error.message);
  }
};

const isBlockedDomain = (data = "") => {
  try {
    const normalized = data.trim().toLowerCase();
    const restrictedWords = JSON.parse(
      process.env.REACT_APP_LONGSWITCH_ACADEMY_BLOCKED_DOMAIN
    );
    const regex = new RegExp("\\b(" + restrictedWords.join("|") + ")\\b", "gi");
    return (restrictedWords || []).some((item) =>
      normalized.includes(item.toLowerCase())
    );
  } catch (error) {
    console.log(
      "305 : Error in isBlockedDomain : ",
      error && JSON.stringify(error)
    );
  }
};

const isBlockedMobileNo = (data = "") => {
  try {
    const normalized = data.trim().toLowerCase();
    const restrictedWords = JSON.parse(
      process.env.REACT_APP_LONGSWITCH_ACADEMY_BLOCKED_MOBILE_NOS
    );
    const regex = new RegExp("\\b(" + restrictedWords.join("|") + ")\\b", "gi");
    return (restrictedWords || []).some((item) =>
      normalized.includes(item.toLowerCase())
    );
  } catch (error) {
    console.log(
      "305 : Error in isBlockedMobileNo : ",
      error && JSON.stringify(error)
    );
  }
};

const isBlockedLinkedInId = (data = "") => {
  try {
    const normalized = data.trim().toLowerCase();
    const restrictedWords = JSON.parse(
      process.env.REACT_APP_LONGSWITCH_ACADEMY_BLOCKED_LINKEDIN_IDS
    );
    const regex = new RegExp("\\b(" + restrictedWords.join("|") + ")\\b", "gi");
    return (restrictedWords || []).some((item) =>
      normalized.includes(item.toLowerCase())
    );
  } catch (error) {
    console.log(
      "305 : Error in isBlockedLinkedInId : ",
      error && JSON.stringify(error)
    );
  }
};

// for checking media URL
const checkMediaUrl = (media) => {
  try {
    return media !== "#" && media.length > 0
  } catch (error) {
    console.log("367 : Index : utils : Error while checking Media URL :", error && JSON.stringify(error));
  }
}

// for getting Yt thumbnail
const getThumbnailFromYouTube = (videoUrl) => {
  try {
    // Regular expression to match the Youtube video url and extract the video id
    const regex =
      /(?:youtube\.com\/(?:[^/]+\/\S+\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    // match the provided video url with regular expression
    const match = videoUrl?.match(regex);
    // Check if the videoUrl matches the YouTube URL pattern
    if (match && match.length) {
      return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
    } else {
      return null; // Return a default image if the URL is not valid
    }
  } catch (error) {
    console.log("387 : Index : utils : Error while gettting Thumbnail From YouTube :", error && JSON.stringify(error));
  }
};

// for format product name
const handleFormatProductName = (productName) => {
  try {
    return productName?.trim()?.toLowerCase()?.replaceAll("(3 months)", "")?.replaceAll("(6 months)", "")?.replaceAll("(9 months)", "");
  } catch (error) {
    console.log(
      "397 : Index : utils : Error in handleFormatProductName : ",
      error && JSON.stringify(error)
    );
  }
};

// for format the date in e.g 1st Jan 2026
const formatDateWithSuffix = (dateString) => {
  try {
    const date = new Date(dateString);
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }
    const day = date.getDate();
    const dayWithSuffix = day + getOrdinalSuffix(day);
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear();
    return `${dayWithSuffix} ${month} ${year}`;
  } catch (error) {
    console.log("458 : Index : utils : Error in formatDateWithSuffix : ", error && JSON.stringify(error));
  }
}

// for format the date in e.g Jan 1-2026
const formatDateWithSuffixV2 = (dateString) => {
  try {
    // 1. Remove the ordinal suffix (e.g., 'rd') to make it standard
    const cleanDate = dateString.replace(/(st|nd|rd|th)/, "");

    // 2. Parse into a Date object
    const dateObj = new Date(Date.parse(cleanDate));

    // 3. Format as "Jun 23-2026" using Intl.DateTimeFormat
    const formatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedParts = formatter.formatToParts(dateObj);
    const month = formattedParts.find(p => p.type === 'month').value;
    const day = formattedParts.find(p => p.type === 'day').value;
    const year = formattedParts.find(p => p.type === 'year').value;

    return `${month} ${day}, ${year}`;
  } catch (error) {
    console.log("458 : Index : utils : Error in formatDateWithSuffix2 : ", error && JSON.stringify(error));
  }
}

/**
 * Converts text to uppercase and replaces spaces with underscores.
 * Safely handles null, undefined, or non-string inputs.
 */
const toUpperSnake = (text) => {
  try {
    if (typeof text !== 'string') return '';
    return text.toUpperCase().replace(/[\s-]+/g, '_');
  } catch (error) {
    console.log("514 : Index : utils : Error in toUpperSnake : ", error && JSON.stringify(error));
  }
};

const getQuestionNumber = (index, currentPage, pageSize = 10) => {
  try {
    return (currentPage) * pageSize + index + 1;
  } catch (error) {
    console.log("522 : Index : Utils : Error in getQuestionNumber", error && JSON.stringify(error));
  }
};

// Function to replace all digits with X
const maskPrice = (price) => {
  return String(price).replace(/\d/g, 'X');
};

// Function for count Reactions
const countReactions = (interactionData, reactionField) => {
  if (!Array.isArray(interactionData) || !reactionField) return 0;

  return interactionData.filter(item => item && item[reactionField] === true).length;
};

// formatPayment Numbers
function formatINR(amount, includeSymbol = false) {
  const number = Number(amount);

  if (isNaN(number)) {
    return '0';
  }

  return new Intl.NumberFormat('en-IN', {
    style: includeSymbol ? 'currency' : 'decimal',
    currency: 'INR',
  }).format(number);
}

// Get a cropped image using canvas
const getCroppedImage = (imageSrc, pixelCrop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 200;
        canvas.height = 200;

        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          200,
          200
        );

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Failed to crop image"));
            }
          },
          "image/jpeg",
          0.95
        );
      } catch (error) {
        console.log("591 : Index : utils : Error in getCroppedImage :", error);
      }
    };

    image.onerror = () => {
      reject(new Error("Failed to load image"));
    };

    image.src = imageSrc;
  });
};

export {
  flatDeep,
  slugify,
  containsObject,
  formatPrice,
  getUniqueValues,
  getUniqueValues2,
  getCategorizedData,
  getAllCategorizedData,
  setCookie,
  _setBgColor,
  extractContent,
  readingTime,
  toggle_password,
  copy_to_clipboard,
  getOrCreateGuestId,
  truncateText,
  isBlockedDomain,
  isBlockedMobileNo,
  isBlockedLinkedInId,
  checkMediaUrl,
  getThumbnailFromYouTube,
  handleFormatProductName,
  formatDateWithSuffix,
  formatDateWithSuffixV2,
  slugifyV2,
  toUpperSnake,
  getQuestionNumber,
  maskPrice,
  countReactions,
  formatINR,
  getCroppedImage,
};
